export default __webpack_public_path__ + "static/media/weekly_accuracy_icon.7d94875a.svg";